// extracted by mini-css-extract-plugin
export var actionButton = "_jo-t";
export var buttonContainer = "_jo-0";
export var buttonContainer2 = "_jo-1";
export var buttonSection = "_jo-2";
export var details = "_jo-3";
export var dropdownItem = "_jo-5";
export var dropdownItemsContainer = "_jo-4";
export var fileInput = "_jo-r";
export var headerButton = "_jo-6";
export var icon = "_jo-7";
export var input = "_jo-8";
export var macroListItem = "_jo-9";
export var mainContent = "_jo-a";
export var microText = "_jo-b";
export var modal = "_jo-w";
export var optionsButton = "_jo-c";
export var paperclip = "_jo-s";
export var pillContent = "_jo-d";
export var preview = "_jo-e";
export var preview2 = "_jo-f";
export var quillEditor = "_jo-q";
export var selectedMacro = "_jo-g";
export var sidebar = "_jo-h";
export var sidebarHeader = "_jo-j";
export var sidebarList = "_jo-i";
export var sidebarListItem = "_jo-k";
export var sidebarSearch = "_jo-l";
export var snoozeDurationWrapper = "_jo-v";
export var statusPillContainer = "_jo-m";
export var tagsContainer = "_jo-n";
export var unselectedMacro = "_jo-o";
export var variable = "_jo-u";
export var wrapper = "_jo-p";